import React, { useState } from "react";
import { Link } from "react-router-dom";
// import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
// import * as Icons from "react-icons/fa";

import HLZLogo from '../images/ComponentImg/Logo/hlz-logo.png';
import { navItems } from "./NavItems";
import SignUpButton from "./SignUpButton";
import ProdDropdown from "./ProdDropdown";
import ServDropdown from "./ServDropdown";
import SuppDropdown from "./SuppDropdown";
import "./Navigatebar.css";

function Navigatiebar() {
  const [proddropdown, setProdDropdown] = useState(false);
  const [servdropdown, setServDropdown] = useState(false);
  const [suppdropdown, setSuppDropdown] = useState(false);

  return (
    <div>
      {/* <Navbar variant='dark' bg='dark' expand="lg" sticky='top'> */}
      <Navbar variant='dark' expand="lg" sticky='top'>
        <Container>
          <div>
            <a className='navbar-logo' href="/">
              <img src={HLZLogo} className='img-fluid w-40' alt="HLZ Logo" />
              <h2> HLZ Technology </h2>
            </a>
          </div>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse className='icons' style={{ justifyContent: 'end' }}>
            <ul className='nav-items'> {
              navItems.map((item) => {
                if (item.title === "Services") {
                  return (
                    <li
                      key={item.id}
                      className={item.cName}
                      onMouseEnter={() => setServDropdown(true)}
                      onMouseLeave={() => setServDropdown(false)}
                    >
                      <Link to={item.path}>{item.title}</Link>
                      {servdropdown && <ServDropdown />}
                    </li>
                  );
                }
                if (item.title === "Products") {
                  return (
                    <li
                      key={item.id}
                      className={item.cName}
                      onMouseEnter={() => setProdDropdown(true)}
                      onMouseLeave={() => setProdDropdown(false)}
                    >
                      <Link to={item.path}>{item.title}</Link>
                      {proddropdown && <ProdDropdown />}
                    </li>
                  );
                }
                if (item.title === "Supports") {
                  return (
                    <li
                      key={item.id}
                      className={item.cName}
                      onMouseEnter={() => setSuppDropdown(true)}
                      onMouseLeave={() => setSuppDropdown(false)}
                    >
                      <Link to={item.path}>{item.title}</Link>
                      {suppdropdown && <SuppDropdown />}
                    </li>
                  );
                }
                return (
                  <li key={item.id} className={item.cName}> <Link to={item.path}>{item.title}</Link> </li>
                );
              })
            } </ul>
            <SignUpButton />
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div >
  );
}

export default Navigatiebar;

// function Navigationbar() {
//   return (
//     <div>
//       <Navbar variant='dark' bg='dark' expand="lg" sticky='top'>
//         <Container>
//           <Navbar.Brand href="/" style={{ fontFamily: 'Oxygen' }}>React-Bootstrap</Navbar.Brand>
//           <Navbar.Toggle aria-controls="basic-navbar-nav" />
//           <Navbar.Collapse className='icons' style={{ justifyContent: 'end' }}>
//             <Nav className="me-auto">
//               <Nav.Link href="/carousel">Carousel</Nav.Link>
//               <Nav.Link href="/card">Card</Nav.Link>
//             </Nav>
//             <Nav style={{ gap: '0.5rem', alignItems: 'center' }}>
//               <img src={git} alt='git' ></img>
//               <img src={twitter} alt='twitter'></img>
//               <img src={linkedin} alt='linkedin'></img>
//             </Nav>
//           </Navbar.Collapse>
//         </Container>
//       </Navbar>
//     </div>
//   )
// }


/*
<Navbar.Brand>
  <img src={HLZLogo} className='img-fluid w-20' alt="" />
  <Link to="/" className='navbar-brand text-success fw-semibold'>
    <h1>HLZ Touch</h1>
  </Link>
</Navbar.Brand>
*/

